import { Routes, Route } from "react-router-dom";
import { NewsData } from "../../../components/news/types";
import NewsPage from "../NewsPage";
import NewsList from "../../../components/news/NewsList";

const SystemRoute = (props: {news_data: NewsData}) => {
    return (
    <>
        <Routes>
            <Route
                path=""
                element={
                    <NewsList
                        news_data={props.news_data}
                        defaultSelectedCategory="supported_system_information"
                    />
                }
            />
            <Route 
                path={"/:newsId"}
                element={
                    <NewsPage
                        newsList={props.news_data.supported_system_information}
                        category="supported_system_information"
                    />
                }
            />
        </Routes>
    </>
    );
}

export default SystemRoute;